import { render, staticRenderFns } from "./ChangePlanPage.vue?vue&type=template&id=bfafb5f4&scoped=true"
import script from "./ChangePlanPage.vue?vue&type=script&lang=js"
export * from "./ChangePlanPage.vue?vue&type=script&lang=js"
import style0 from "./ChangePlanPage.vue?vue&type=style&index=0&id=bfafb5f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfafb5f4",
  null
  
)

export default component.exports